import axios from 'axios'
import HTTP from './http'

export default {
    getList: () => axios.get(HTTP.SPECIALIZATIONS)
}
